'use strict'

function moveListItem (list, index, direction) {

  if (!Array.isArray(list)) return false

  const delta = direction === 'up' ? -1 : direction === 'down' ? 1 : 0

  if (!delta) return false

  const next = index + delta

  if (index < 0 || index >= list.length || next < 0 || next >= list.length) return false

  const item = list.splice(index, 1)[0]

  list.splice(next, 0, item)

  return true
}

module.exports = {
  moveListItem
}
